import React, { useState, useRef, useEffect } from 'react';

import './Login.css';
import { useDispatch } from 'react-redux';
import { setTokens } from '../../store/tokensSlice'; // Import akcji Redux
import { useNavigate } from 'react-router-dom';
import { ReactComponent as MapenLogo } from '../icons/logo.svg';
import ApiService from '../api_services/apiService.jsx'; // Import ApiService
import OrganizerRegistration from './organizerRegistration.jsx';

function Login() {
  const [showLogin, setShowLogin] = useState(true);
  const [showRegistration, setShowRegistration] = useState(false);
  const [isEmailChecked, setIsEmailChecked] = useState(false);
  const [isEmailExists, setIsEmailExists] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const dispatch = useDispatch();
  const navigate = useNavigate();

    const passwordInputRef = useRef(null);

    // Walidacja hasła jak na backendzie:
    // min 8 znaków, 1 wielka litera, min 1 cyfra, min 1 znak specjalny z podanego zbioru
    const PASSWORD_REGEX =
        /^(?=.*[A-Z])(?=(?:.*\d){1,})(?=.*[!@#$%^&*()_+=?<>{}\[\]-]).{8,}$/;

    const validatePasswordForRegistration = (value) => PASSWORD_REGEX.test(value);

    const isRegistrationPasswordContext = isEmailChecked && !isEmailExists;
    const isPasswordTouched = password && password.length > 0;
    const isPasswordValidForRegistration =
        isRegistrationPasswordContext && validatePasswordForRegistration(password);
    const isPasswordHasNumber = /\d/.test(password);
    const isPasswordHasSpecialChar = /[!@#$%^&*()_+=?<>{}\[\]-]/.test(password);
    const isPasswordHasUpperCase = /[A-Z]/.test(password);

    const isPasswordHasMinLength = password && password.length >= 8;

    const [isModalOpen, setIsModalOpen] = useState(false);

    const toggleModal = (e) => {
        e.preventDefault(); // Zapobiega przeładowaniu strony
        e.stopPropagation(); // Zapobiega przypadkowemu zaznaczeniu checkboxa przy kliku w link
        setIsModalOpen(true);
    };


    const [termsAccepted, setTermsAccepted] = useState(false);
    const [privacyPolicyAccepted, setPrivacyPolicyAccepted] = useState(false);

    console.log('isEmailChecked:', isEmailChecked, 'username:', username);

    // useEffect do focusowania na polu hasła po sprawdzeniu emaila
    useEffect(() => {
        if (isEmailChecked && passwordInputRef.current) {
            passwordInputRef.current.focus();
        }
    }, [isEmailChecked]);

    // Funkcja obsługująca zakończenie rejestracji
    const handleRegistrationComplete = (credentials) => {
        // Ustawienie email i hasła z rejestracji
        setUsername(credentials.email);
        setPassword(credentials.password);
        setShowRegistration(false);
        setShowLogin(true)
        setIsEmailChecked(false);
        alert('Prawe gotowe!\nPotwierdź swój adres e-mail, a nastepnie zajmiemy się weryfikacją Twojego konta organizatora.\n Damy Ci znać mailowo, gdy wszystko bedzie gotowe.\n\nSprawdzamy zgłoszenia na bieżąco, więc weryfikacja nie powinna zająć dużo czasu.')
        // alert('Rejestracja zakończona pomyślnie!\nOczekuj na akceptację administratora!\n\nInformację otrzymasz na podany adres e-mail.');
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            // KROK 1: Sprawdzenie czy email istnieje
            if (!isEmailChecked) {
                if (!username.trim()) {
                    alert('Wprowadź adres e-mail');
                    return;
                }

                // Sprawdzenie czy email istnieje w systemie
                const checkEmailResponse = await ApiService.get('/api/auth/is-email-exists?email=' + username);

                console.log('Odpowiedź sprawdzenia emaila:', checkEmailResponse);

                // Ustawienie stanów na podstawie odpowiedzi
                setIsEmailChecked(true);
                setIsEmailExists(checkEmailResponse.data.isAccountExists || false);

                return; // Zakończenie dla kroku 1
            }

            // KROK 2: Logowanie istniejącego użytkownika
            if (isEmailChecked && isEmailExists) {
                if (!password.trim()) {
                    alert('Wprowadź hasło');
                    return;
                }

                const response = await ApiService.post('/api/auth/login', {
                    email: username,
                    password: password,
                });

                if (response.data?.status === 'UNAUTHORIZED' && response.data?.message === 'User is not activated.') {
                    alert('❌ Twoje konto nie zostało aktywowane. Sprawdź swoją skrzynkę e-mail i kliknij link aktywacyjny.');
                    return;
                }

                console.log('Odpowiedź z API logowania:', response);

                if (response.data && (response.data.userRole === '[SYSTEM_ADMIN]' || response.data.userRole === '[EVENT_ADMIN]' )) {
                    dispatch(setTokens({
                        accessToken: response.data.accessToken,
                        refreshToken: response.data.refreshToken,
                        userEmail: response.data.userEmail,
                        userPhoneNumber: response.data.userPhoneNumber,
                        accessTokenExpiration: response.data.accessTokenExpiresAt,
                        refreshTokenExpiration: response.data.refreshTokenExpiresAt,
                        userRole: response.data.userRole,
                    }));

                    // Przekierowanie po udanym logowaniu (opcjonalne)
                    navigate('/');

                } else if (response.data && !(response.data.userRole === '[SYSTEM_ADMIN]' || response.data.userRole === '[EVENT_ADMIN]' )) {
                    alert('Nie jesteś administratorem! Nie masz dostępu do tego systemu!');
                } else {
                    alert('Nieprawidłowa odpowiedź z serwera.');
                }

                return; // Zakończenie dla kroku 2
            }

            // KROK 3: Rejestracja nowego użytkownika
            if (isEmailChecked && !isEmailExists) {

                if (!password.trim()) {
                    alert('Wprowadź hasło');
                    return;
                }

                if (!validatePasswordForRegistration(password)) {
                    alert(
                        'Hasło musi mieć min. 8 znaków, 1 wielką literę, min. 1 cyfrę oraz min. 1 znak specjalny (!, @, #, $, %, ^, &, *, (, ), _, +, =, ?, <, >, {, }, [, ], -).'
                    );
                    return;
                }

                setShowRegistration(true)
                setShowLogin(false)
            }

        } catch (error) {
            console.error('Błąd podczas przetwarzania:', error);

            // Różne komunikaty błędów dla różnych kroków
            if (!isEmailChecked) {
                alert('Nie udało się sprawdzić adresu e-mail. Spróbuj ponownie.');
            } else if (isEmailExists) {
                alert('Nie udało się zalogować. Sprawdź swoje dane logowania.');
            } else {
                alert('Nie udało się utworzyć konta. Spróbuj ponownie.');
            }
        }
    };

    // Funkcja do powrotu do pierwszego kroku (opcjonalna)
    const resetForm = () => {
        setIsEmailChecked(false);
        setIsEmailExists(false);
        setUsername('');
        setPassword('');
    };

    // Funkcja do ustalenia tekstu na przycisku
    const getButtonText = () => {
        if (!isEmailChecked) {
            return 'Kontynuuj';
        } else if (isEmailExists) {
            return 'Zaloguj się';
        } else {
            return 'Załóż konto organizatora';
        }
    };

    // Funkcja do ustalenia autoComplete dla pola hasła
    const getPasswordAutoComplete = () => {
        if (isEmailExists) {
            return 'current-password';
        } else {
            return 'new-password';
        }
    };

  return (
    <>
      {showRegistration && <OrganizerRegistration
          onBack={() => {
              setShowRegistration(false);
              setShowLogin(true);
          }}
          initialEmail={username}
          initialPassword={password}
          onRegistrationComplete={handleRegistrationComplete}
      />}

        {showLogin && <div className="login-page">
          <div className="login-container">
            <h1 className="login-title">
                <MapenLogo />
            </h1>
            <p className="login-subtitle">Panel organizatora</p>
            <p className="login-instruction">Uzupełnij dane, aby kontynuować</p>

            <form className="login-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="username">Adres e-mail</label>
                <input
                  type="email"
                  id="username"
                  placeholder="Wpisz adres email"
                  value={username}
                  onChange={(e) => {
                      setIsEmailChecked(false);
                      setIsEmailExists(false);
                      setPassword('');
                      setUsername(e.target.value)
                  }}
                  autoComplete="email"
                />
              </div>

              {isEmailChecked && (
                <div className="form-group">
                    <label
                        htmlFor="password"
                        style={{
                            display: 'flex',
                            alignItems: 'baseline',
                            justifyContent: 'space-between',
                            gap: 12,
                        }}
                    >
                        <span>Hasło</span>

                        {isRegistrationPasswordContext && (
                            <span
                                className={[
                                    'password-hint',
                                    !isPasswordTouched
                                        ? 'password-hint--neutral'
                                        : isPasswordValidForRegistration
                                            ? 'password-hint--ok'
                                            : 'password-hint--warn',
                                ].join(' ')}
                            >
        {!isPasswordTouched || isPasswordValidForRegistration ? (
            // Wyświetla prosty komunikat, gdy pole nie jest ruszone lub hasło jest poprawne
            !isPasswordTouched
                ? 'Wymagania: 8 znaków, 1 wielka litera, 1 cyfra, 1 znak specjalny'
                : 'Hasło OK'
        ) : (
            // Wyświetla dynamiczną listę wymagań z kolorami
            <>
                Wymagania:
                <span className={isPasswordHasMinLength ? "pass-green" : "pass-orange"}> 8 znaków</span>,
                <span className={isPasswordHasUpperCase ? "pass-green" : "pass-orange"}> 1 wielka litera</span>,
                <span className={isPasswordHasNumber ? "pass-green" : "pass-orange"}> 1 cyfra</span>,
                <span className={isPasswordHasSpecialChar ? "pass-green" : "pass-orange"}> 1 znak specjalny</span>
            </>
        )}
    </span>
                        )}
                    </label>

                  <input
                    ref={passwordInputRef}
                    type="password"
                    id="password"
                    placeholder="Wpisz hasło"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    autoComplete={getPasswordAutoComplete()}
                  />
                    <div className="checkbox-container-terms">
                        <div className={!isPasswordValidForRegistration ? "disabled-terms" : ""} >
                          <label className="checkbox-terms disabled-terms" htmlFor="regulamin">
                            <input
                                type="checkbox"
                                id="regulamin"
                                name="regulamin"
                                checked={termsAccepted} // Powiązanie ze stanem
                                onChange={(e) => setTermsAccepted(e.target.checked)} // Aktualizacja stanu
                                />
                            <span className="checkbox-text">
                            Akceptuję <span className="terms-link" onClick={toggleModal}>regulamin</span>
                            </span>
                          </label>
                        </div>
                        <div className={!isPasswordValidForRegistration ? "disabled-terms" : ""} >
                          <label className="checkbox-terms disabled-terms" htmlFor="polityka">
                              <input
                                  type="checkbox"
                                  id="polityka"
                                  name="polityka"
                                  checked={privacyPolicyAccepted} // Powiązanie ze stanem
                                  onChange={(e) => setPrivacyPolicyAccepted(e.target.checked)} // Aktualizacja stanu
                              />
                              <span className="checkbox-text">
                              Zapoznałem/-am się z Polityką prywatności
                              </span>
                          </label>
                        </div>

                        {/* Proste okno modalne */}
                        {isModalOpen && (
                            <div className="modal-overlay">
                                <div className="modal-content">
                                    <h2>Regulamin</h2>
                                    <div className="modal-body">
                                        <iframe
                                            title="Regulamin MAPEN"
                                            src="/Regulamin MAPEN-2.pdf"
                                            style={{ width: '100%', height: '70vh', border: 'none' }}
                                        />
                                    </div>
                                    <button onClick={() => setIsModalOpen(false)}>Zamknij</button>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className={'left-text text-small'}>
                        Na start zaczynamy od prostych i potrzebnych rozwiązań dla organizatorów
                        wydarzeń
                        <ul>
                            <li>Publikujesz wydarzenia szybko i bez opłat</li>
                            <li>Twoje wydarzenia są prezentowane użytkownikom aplikacji</li>
                            <li>Otrzymujesz dostęp do podstawowych statystyk zainteresowania</li>
                        </ul>
                        Korzystanie z platformy jest obecnie w pełni bezpłatne.<br/>
                        Na początku koncentrujemy się na budowaniu społeczności i wspieraniu
                        organizatorów w dotarciu do uczestników. W przyszłości mogą pojawić się
                        dodatkowe funkcje płatne lub modele subskrypcyjne - o wszelkich zmianach
                        poinformujemy z wyprzedzeniem.<br/><br/>
                    </div>
                </div>
              )}

                <button
                    disabled={(isRegistrationPasswordContext && (!isPasswordValidForRegistration || !termsAccepted || !privacyPolicyAccepted))}
                    type="submit" className="login-button">
                    {getButtonText()}
                </button>
            </form>

          </div>
        </div>
        }
    </>
  );
}

export default Login;
